import api from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8081';

// Leaderboard APIs - Fixed sorting parameter to match backend field names
export const getWeeklyLeaderboard = (page = 0, size = 10, sort = 'totalPoints,desc') => {
    return api.get(`/api/rewards/leaderboard/weekly`, {
        params: { page, size, sort }
    });
};

export const getMonthlyLeaderboard = (page = 0, size = 10, sort = 'totalPoints,desc') => {
    return api.get(`/api/rewards/leaderboard/monthly`, {
        params: { page, size, sort }
    });
};

export const getAllTimeLeaderboard = (page = 0, size = 10, sort = 'rewardsPoints,desc') => {
    return api.get(`/api/rewards/leaderboard/alltime`, {
        params: { page, size, sort }
    });
};

export const getRewardHistory = (page = 0, size = 10) => {
    return api.get(`/api/rewards/history`, {
        params: { page, size }
    });
};

export const getBadges = () => {
    return api.get(`/api/rewards/badges`);
};

export const getUserStats = () => {
    return api.get(`/api/rewards/stats`);
};

export const getUserLevel = () => {
    return api.get(`/api/rewards/level`);
};

// Generic leaderboard function for different periods - Fixed sorting parameter
export const getLeaderboard = (period, page = 0, size = 10, sort = null) => {
    // Use appropriate default sort for each period
    const defaultSort = period === 'alltime' ? 'rewardsPoints,desc' : 'totalPoints,desc';
    const finalSort = sort || defaultSort;

    return api.get(`/api/rewards/leaderboard/${period}`, {
        params: { page, size, sort: finalSort }
    });
};

export default api;
